import {Vue, Component} from 'vue-property-decorator';
import { generateUriWithQuery, ncpPopup } from '@/utils/commonUtils';
import {State} from 'vuex-class';
import {Mall} from 'supporter';
import $ from 'jquery';
import { GetOrdersByOrderNoFreeGiftsResponse } from 'ncp-api-supporter/dist/types';

@Component
export default class OrderGridsColumns extends Vue {
  public get orderNo(): string {
    return `${this.$route.query.orderNo}`;
  }
  
  public summaryOrderNo: string = '';
  public summaryCancelCnt: number = 0;
  public summaryOrderCnt: number = 0;
  public summaryReturnCnt: number = 0;
  public summaryRowCnt: number = 0;
  public memberInfo: any = {};
  public orderInfo: any = {};
  public initPayInfo: any = {};
  public endPayInfo: any = {};
  public freeGiftDiscountAmount = 0;
  public freeGifts: GetOrdersByOrderNoFreeGiftsResponse[] = [];
  public task: any = {
    taskMessageStatus: 'PROCESSING',
    taskMessageType: 'PRODUCT',
    taskMessageTargetType: 'PARTNER',
    orderProductOptionNo: undefined,
    content: null
  };
  public cs: any = {
    csStatusType: 'PROCESSING',
    csType: 'PRODUCT',
    csPathType: 'IN_BOUND',
    orderProductOptionNo: undefined,
    content: null
  };
  public csPathTypeArr: any[] = [
    {value: 'IN_BOUND', label: 'ORDER_ORDER_DETAIL_CS_PATH_IN_BOUND'},
    {value: 'OUT_BOUND', label: 'ORDER_ORDER_DETAIL_CS_PATH_OUT_BOUND'},
    {value: 'ETC', label: 'ORDER_ORDER_DETAIL_CS_PATH_ETC'}
  ];
  public taskMessageStatusTypeArr: any[] = [
    {value: 'PROCESSING', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_STATUS_TYPE_PROCESSING'},
    {value: 'DONE', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_STATUS_TYPE_DONE'}
  ];
  public taskMessageTypeArr: any[] = [
    {value: 'PAY', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_PAY'},
    {value: 'PRODUCT', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_PRODUCT'},
    {value: 'DELIVERY', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_DELIVERY'},
    {value: 'CLAIM', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_CLAIM'},
    {value: 'REFUND', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_REFUND'},
    {value: 'ETC', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_ETC'}
  ];

  public taskMessageTargetTypeArr: any[] = [
    {value: 'PARTNER', label: 'ORDER_ORDER_DETAIL_MESSAGE_TARGET_TYPE_PARTNER'},
    {value: 'SERVICE', label: 'ORDER_ORDER_DETAIL_MESSAGE_TARGET_TYPE_SERVICE'}
  ];
  public orderProductOptionNoArr: any[] = [];
  public productUrl: string = '';

  @State('malls', {namespace: 'mall'})
  public malls!: Mall[];

  public changePayBank(claimNo: any): void {
    let title: any = this.$t('ORDER_ORDER_DETAIL_CHANGE_APY_BANK_TITLE');
    ncpPopup(`/claim/changePayBank?claimNo=${claimNo}`, title, 600, 500);
  }
  public changeBankIfno(claimNo: any): void {
    let title: any = this.$t('ORDER_ORDER_DETAIL_CHANGE_REFUND_BANK_TITLE');
    ncpPopup(`/claim/changeRefundBank?claimNo=${claimNo}`, title, 600, 500);
  }
  public handleReceiverInfoChange(shippingNo: any, invoiceNo: any, orderInfoPayType: string): void {
    // 이유는 모르겠지만 한글로 타입이 set 되어있음. 한국만 네이버 사용해서 문제될거같진 않아서 한글비교함
    if(orderInfoPayType === '네이버페이 주문형'){
      alert('네이버페이 주문형 주문은 네이버페이센터를 통해 처리해 주세요.')
      return
    }

    let title: any = this.$t('ORDER_ORDER_DETAIL_RECEIVER_INFO_CHANGE_TITLE');
    if (!invoiceNo) {
      ncpPopup(`/delivery/modifyPopup?shippingNo=${shippingNo}&orderNo=${this.summaryOrderNo}`, title, 1024, 500);
    } else {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_5'));
    }
  }
  public onClickExpand(ev: any): void {
    $(ev.target)
      .parent('.table_tit_area')
      .toggleClass('is_expanded');
  }
  public onClickOrdererPopup(): void {
    let title: any = this.$t('ORDER_ORDER_DETAIL_MEMBER_PUPOP_TITLE');
    ncpPopup(`/member/popup/crm/${this.memberInfo.memberNo}`, title, 1100, 980);
  }
  public onClickAccumulationAmt(): void {
    let title: any = this.$t('ORDER_ORDER_DETAIL_BENEFIT_TITLE');
    ncpPopup(`/order/benefit?orderNo=${this.summaryOrderNo}`, title, 600, 400);
  }
  public onClickFirstDiscountAmt(): void {
    let title: any = this.$t('ORDER_ORDER_DETAIL_FIRST_DISCOUNT_TITLE');
    ncpPopup(`/order/first-discount?orderNo=${this.summaryOrderNo}`, title, 600, 400);
  }
  public onClickLastDiscountAmt(): void {
    let title: any = this.$t('ORDER_ORDER_DETAIL_LAST_DISCOUNT_TITLE');
    ncpPopup(`/order/last-discount?orderNo=${this.summaryOrderNo}`, title, 600, 400);
  }
  public onClickFirstDeliveryAmtPopup(): void {
    let title: any = this.$t('ORDER_ORDER_DETAIL_FIRST_AMT_DETAIL_TITLE');
    ncpPopup(`/delivery/first-amt-detail?orderNo=${this.summaryOrderNo}`, title, 300, 300);
  }
  public onClickLastDeliveryAmtPopup(): void {
    let title: any = this.$t('ORDER_ORDER_DETAIL_LAST_AMT_DETAIL_TITLE');
    ncpPopup(`/delivery/last-amt-detail?orderNo=${this.summaryOrderNo}`, title, 300, 300);
  }
  public openFreeGiftsConditionNoPopup(conditionNo: number) {
    const title = '사은품혜택 상세';
    
    const matchedFreeGift = this.freeGifts.find(({ conditionNo: no }) => no === conditionNo)
    
    const uri = generateUriWithQuery('/order/free-gifts', {
      orderNo: this.orderNo,
      productUrl: this.productUrl,
      data: JSON.stringify(matchedFreeGift)
    });
    
    ncpPopup(uri, title, 900, 800);
  }
  
  public setFreeGiftDiscountAmount(data) {
    this.freeGiftDiscountAmount = data.orderProducts[0].orderOptions.map(({ freeGiftDiscountAmt }) => freeGiftDiscountAmt).reduce((acc, curr) => acc += curr, 0);
  }
}
